import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { buildComponentName } from '../utils';
import { scrollTo, updatePortalElement } from './utils';
export default {
  name: buildComponentName('TimepickerSelect'),
  props: {
    prefixCls: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    triggerRef: {
      type: Object,
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      active: false
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          active = this.active;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-select"), true), _defineProperty(_ref, "".concat(prefixCls, "-select-active"), active), _ref;
    },
    children: function children() {
      return this.renderChildren();
    }
  },
  watch: {
    visible: function visible(nVal) {
      var _this = this;

      if (nVal === false) {
        setTimeout(function () {
          _this.scrollToTarget(0);
        }, 100);
      }
    },
    triggerRef: function triggerRef() {
      this.mountScrollToTarget();
    }
  },
  created: function created() {
    this.prevSelectedValue = null;
    this.currentSelectedValue = null;
  },
  mounted: function mounted() {
    this.mountScrollToTarget();
  },
  updated: function updated() {
    var prevSelectedValue = this.prevSelectedValue,
        currentSelectedValue = this.currentSelectedValue,
        scrollToTarget = this.scrollToTarget;

    if (currentSelectedValue && currentSelectedValue !== prevSelectedValue) {
      scrollToTarget(120);
    }
  },
  methods: {
    onSelect: function onSelect(item) {
      var type = this.type;

      if (!item.isDisabled) {
        this.$emit('select', type, item.value);
      }
    },
    onMouseEnter: function onMouseEnter(e) {
      this.active = true;
      this.$emit('mouseenter', e);
    },
    onMouseLeave: function onMouseLeave() {
      this.active = false;
    },
    mountScrollToTarget: function mountScrollToTarget() {
      var _this$$refs = this.$refs,
          wrapRef = _this$$refs.wrapRef,
          selectedRef = _this$$refs.selectedRef,
          triggerRef = this.triggerRef;

      if (selectedRef) {
        var alignElement;

        if (triggerRef) {
          alignElement = triggerRef.getPortalPopupElement();
        }

        updatePortalElement(alignElement, function () {
          scrollTo(wrapRef, selectedRef.offsetTop, 0);
        });
      }
    },
    scrollToTarget: function scrollToTarget() {
      var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 120;
      var _this$$refs2 = this.$refs,
          wrapRef = _this$$refs2.wrapRef,
          selectedRef = _this$$refs2.selectedRef;

      if (selectedRef) {
        scrollTo(wrapRef, selectedRef.offsetTop, duration);
      }
    },
    renderChildren: function renderChildren() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          options = this.options,
          onSelect = this.onSelect;
      var optionNodes = options.map(function (item) {
        var _cls;

        var cls = (_cls = {}, _defineProperty(_cls, "".concat(prefixCls, "-select-option-selected"), item.isSelected), _defineProperty(_cls, "".concat(prefixCls, "-select-option-disabled"), item.isDisabled), _cls);
        var bindAttrs = {
          class: cls,
          on: {
            click: function click() {
              onSelect(item);
            }
          }
        };

        if (item.isSelected) {
          bindAttrs.ref = 'selectedRef';
        }

        return h("li", _mergeJSXProps([{}, bindAttrs]), [item.value]);
      });
      return h("ul", [optionNodes]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var classes = this.classes,
        children = this.children,
        options = this.options,
        onMouseEnter = this.onMouseEnter,
        onMouseLeave = this.onMouseLeave;
    this.prevSelectedValue = this.currentSelectedValue;
    this.currentSelectedValue = (options.filter(function (v) {
      return v.isSelected;
    })[0] || {}).value || null;
    return h("div", {
      "ref": "wrapRef",
      "class": classes,
      "on": {
        "mouseenter": onMouseEnter,
        "mouseleave": onMouseLeave
      }
    }, [children]);
  }
};